import * as React from 'react';

const SvgCoverage = (props) => (
  <svg
    width={56}
    height={56}
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    {...props}
  >
    <path
      d='M13.067 19.553H9.333A2.34 2.34 0 0 0 7 21.887V49a2.34 2.34 0 0 0 2.333 2.334h3.734A2.34 2.34 0 0 0 15.4 49V21.887a2.325 2.325 0 0 0-2.333-2.334ZM29.867 12.11h-3.733a2.34 2.34 0 0 0-2.333 2.333V49a2.34 2.34 0 0 0 2.333 2.334h3.733A2.34 2.34 0 0 0 32.201 49V14.443a2.34 2.34 0 0 0-2.334-2.333ZM46.666 4.667h-3.733A2.34 2.34 0 0 0 40.6 7v42a2.34 2.34 0 0 0 2.333 2.333h3.733A2.34 2.34 0 0 0 49 49V7a2.34 2.34 0 0 0-2.334-2.333Z'
      fill='#E00034'
    />
  </svg>
);

export default SvgCoverage;
